// Libraries
var React = require('react');
var debounce = require('lodash/debounce');

// Style
require('./MediaHero.scss');

class MediaHeroModule extends React.Component {
  constructor(props) {

    super(props);
    this.mediaHeroWrapper = React.createRef();
    this.mediaHeroWrapperInner = React.createRef();
    this.mediaHeroVideo = React.createRef();

    this.state = {
      videoSource: '',
      lastWindowHeight: 0,
      showVideoPlaceholder: this.props.data.videoLarge
    }

  }

  componentDidMount() {

    if (!this.mediaHeroVideo) return;

    let source = window.matchMedia('(min-width: 641px)').matches ? this.props.data.videoLarge : this.props.data.videoSmall;
    const loopVideo = this.props.data.loopVideo;

    this.setState({
      videoSource: source
    }, () => {
      
      if (source === '' || !source) return;

      this.mediaHeroVideo.current.muted = true;
      this.mediaHeroVideo.current.loop = false;
      this.mediaHeroVideo.current.play();

      this.mediaHeroVideo.current.addEventListener('playing', () => { 
        this.mediaHeroWrapper.current.setAttribute('data-media-hero', 'video-playing'); 
        setTimeout(()=> {
          this.setState({
            showVideoPlaceholder: false
          });
        }, 500);
      });

      this.mediaHeroVideo.current.addEventListener('ended', () => {
        
        if (loopVideo) {

          this.mediaHeroVideo.current.play();

        } else {

          this.mediaHeroWrapper.current.setAttribute('data-media-hero', 'video-ended');

        }

      });

    });

    if (typeof window === 'undefined') return;

    window.addEventListener('resize', debounce(() => { this.setMediaHeroHeight(); }, 500));

    this.setState({
      lastWindowHeight: window.innerHeight
    }, () => {

      this.setMediaHeroHeight();

    });

  }

  setMediaHeroHeight() {

    let element = this.mediaHeroWrapperInner.current;
    let windowHeight = window.innerHeight;

    if (windowHeight === this.state.lastWindowHeight) return;

    this.setState({
      lastWindowHeight: windowHeight
    }, () => {

      element.removeAttribute('style');
      setTimeout(function () {

        element.style.height = element.offsetHeight + 'px';
        element.style.minHeight = element.offsetHeight + 'px';

      }, 100);

    });

  }

  getNextElement(parentElement) {

    if (!parentElement) return null;

    let node = parentElement.nextSibling;

    while (node) {
      if (node.nodeName.toLowerCase() === 'div') return node;
      node = node.nextElementSibling || node.nextSibling;
    }

    return null;

  }

  // Note: On non static versions of the site, each React component is wrapped in a div with an id and followed by a script tag, hence the expanded logic here

  scrollPastMediaHero(wrapper) {

    const parentElement = wrapper.parentNode;
    const isNotStatic = parentElement.hasAttribute('id') && (parentElement.getAttribute('id').indexOf('react_') !== -1);
    const notStaticAbsoluteParent = isNotStatic ? parentElement.closest('[id^="item-"]') : null;

    let target = isNotStatic ? this.getNextElement(notStaticAbsoluteParent) : wrapper.nextSibling;

    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth' });

  }

  render() {
    const hasPrimaryAction = this.props.data.link.url && this.props.data.link.caption;
    const hasSecondaryAction = this.props.data.secondaryLink.url && this.props.data.secondaryLink.caption;

    const additionalMediaHeroClass = this.props.data.isOneHotspur ? ' c-media-hero--one-hotspur' : this.props.data.isPremium ? ' c-media-hero--premium' : '';
    const buttonInformationPrimaryClass = this.props.data.isOneHotspur ? ' c-button--one-hotspur'  : this.props.data.isPremium ? ' c-button--premium' : '';
    const buttonInformationSecondaryClass = this.props.data.isOneHotspur ? ' c-button--one-hotspur c-button--reverse'  : this.props.data.isPremium ? ' c-button--premium' : 'c-button--outline';

    return (
      <div id={this.props.data.id} className={`c-media-hero${additionalMediaHeroClass}`} ref={this.mediaHeroWrapper} data-media-hero>
        <div className="c-media-hero__inner" ref={this.mediaHeroWrapperInner}>
          <div className={`c-media-hero__content${(this.props.data.showTextDuringPlayback || this.props.data.loopVideo || !this.state.videoSource) ? " c-media-hero__content--visible" : ""}`}>
            <div className="c-media-hero__content__restrict">
              {this.props.data.title !== '' &&
                <h1 className="c-media-hero__title">{this.props.data.title}</h1>
              }
              {this.props.data.text !== '' &&
                <p className="c-media-hero__text">{this.props.data.text}</p>
              }
            </div>
            {(hasPrimaryAction || hasSecondaryAction) &&
              <div className="c-media-hero__actions">
                {hasPrimaryAction &&
                                <p className="c-media-hero__action">
                                    <a href={this.props.data.link.url} className={`c-button c-button--on-dark ${buttonInformationPrimaryClass}`} target={this.props.data.link.newWindow ? "_blank" : "_self"} rel={this.props.data.link.newWindow ? "noopener noreferrer" : undefined}>{this.props.data.link.caption}</a>
                  </p>
                }
                {hasSecondaryAction &&
                                <p className="c-media-hero__action">
                                    <a href={this.props.data.secondaryLink.url} className={`c-button c-button--on-dark c-button--outline ${buttonInformationSecondaryClass}`} target={this.props.data.secondaryLink.newWindow ? "_blank" : "_self"} rel={this.props.data.secondaryLink.newWindow ? "noopener noreferrer" : undefined}>{this.props.data.secondaryLink.caption}</a>
                  </p>
                }
              </div>
            }
          </div>
        </div>
        <picture>
          <source media="(min-width: 641px)" srcSet={this.props.data.imageLarge.url} />
          <img src={this.props.data.imageSmall.url} alt="" className="c-media-hero__image" />
        </picture>
        {this.state.showVideoPlaceholder ?
        <div className='c-media-hero__video-placeholder'></div>
        : null}
        {
          this.state.videoSource ?
            <React.Fragment>
              <video ref={this.mediaHeroVideo} className="c-media-hero__video" preload="metadata" playsInline poster="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">
                <source src={this.state.videoSource} type="video/mp4" />
              </video>
            </React.Fragment>
            : null
        }
        {!this.props.data.isOneHotspur &&
          <p className="c-media-hero__scroll">
            <button type="button" className="c-media-hero__scroll__button" onClick={() => this.scrollPastMediaHero(this.mediaHeroWrapper.current)}>
              <span className="u-visually-hidden">Continue to main content</span>
            </button>
          </p>
        }
      </div>
    );
  }
};

module.exports = MediaHeroModule;


// WEBPACK FOOTER //
// ./src/components/MediaHero/MediaHero.js